/**
 * Auto-generated lucide icon component.
 *
 * @see https://lucide.dev/icons/circle-x
 */
import { default as DefaultIcon } from '~icons/lucide/circle-x';
import { Icon, type IconProps } from 'src/components/media-and-icons/icon';

export const CircleXIcon = (props: IconProps) => (
  <Icon icon={DefaultIcon} {...props} />
);
